const parseCalendarDate = (value) => {
    if (typeof value !== "string") return null;

    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
    if (!match) return null;

    const [, yearText, monthText, dayText] = match;
    const year = Number(yearText);
    const month = Number(monthText);
    const day = Number(dayText);
    const isLeapYear = year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
    const daysInMonth = [
        31,
        isLeapYear ? 29 : 28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31,
    ];

    if (month < 1 || month > 12 || day < 1 || day > daysInMonth[month - 1]) {
        return null;
    }

    return { year, month, day };
};

export const getAgeAtConsultation = (birthdate, consultationDate) => {
    const birth = parseCalendarDate(birthdate);
    const visit = parseCalendarDate(consultationDate);

    if (!birth || !visit) return null;

    const visitBeforeBirthday =
        visit.month < birth.month ||
        (visit.month === birth.month && visit.day < birth.day);
    const age = visit.year - birth.year - (visitBeforeBirthday ? 1 : 0);

    return age < 0 ? null : age;
};

const plural = (n, one, many) => `${n} ${n === 1 ? one : many}`;
const daysInMonth = (year, month) => new Date(Date.UTC(year, month, 0)).getUTCDate();

// "14 años"; under one year it switches to "3 meses y 10 días".
export const formatAgeAtConsultation = (birthdate, consultationDate) => {
    const years = getAgeAtConsultation(birthdate, consultationDate);
    if (years === null) return "No disponible";
    if (years >= 1) return plural(years, "año", "años");

    const birth = parseCalendarDate(birthdate);
    const visit = parseCalendarDate(consultationDate);
    let months = (visit.year - birth.year) * 12 + visit.month - birth.month;
    if (visit.day < birth.day) months -= 1;

    // Last "monthiversary", clamped to the month end (Jan 31 + 1 month = Feb 28/29).
    const index = birth.month - 1 + months;
    const year = birth.year + Math.floor(index / 12);
    const month = index % 12;
    const day = Math.min(birth.day, daysInMonth(year, month + 1));
    const days = Math.round(
        (Date.UTC(visit.year, visit.month - 1, visit.day) - Date.UTC(year, month, day)) / 86400000
    );

    return [
        months > 0 && plural(months, "mes", "meses"),
        (days > 0 || months === 0) && plural(days, "día", "días"),
    ]
        .filter(Boolean)
        .join(" y ");
};

const pad = (n) => String(n).padStart(2, "0");

// Age today (same format). `fallbackYears` covers records without a birthdate.
export const formatCurrentAge = (birthdate, fallbackYears) => {
    const now = new Date();
    const today = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
    const text = formatAgeAtConsultation(birthdate, today);
    const years = fallbackYears === null || fallbackYears === "" ? NaN : Number(fallbackYears);
    return text === "No disponible" && Number.isFinite(years) ? plural(years, "año", "años") : text;
};
